import { render, staticRenderFns } from "./FormLoginShareholder.vue?vue&type=template&id=eedcbdce&scoped=true&"
import script from "./FormLoginShareholder.vue?vue&type=script&lang=ts&"
export * from "./FormLoginShareholder.vue?vue&type=script&lang=ts&"
import style0 from "./FormLoginShareholder.vue?vue&type=style&index=0&id=eedcbdce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedcbdce",
  null
  
)

export default component.exports